import React, { useState, useEffect } from "react";
import "./Splash.css";
import { useNavigate } from "react-router-dom"; // Update this line

function AnimatedSplash(props) {
  return (
    <div className="logo_wrapper">
      <div className="loading">
        <div class="ball"></div>
        <div class="ball"></div>
        <div class="ball"></div>
        <div class="ball"></div>
        <div class="ball"></div>
        <div class="ball"></div>
        <div class="ball"></div>
      </div>
    </div>
  );
}

function Splash(props) {
  const [redirect, setRedirect] = useState(false);
  const navigate = useNavigate(); // Add this line

  useEffect(() => {
    if (redirect) {
      navigate('/home'); // Navigate when the `redirect` state is set to true
    }
  }, [redirect, navigate]); // Add `navigate` to the dependency array

  setTimeout(() => setRedirect(true), 2000);

  return redirect ? null : <AnimatedSplash theme={props.theme} />; // Render nothing when `redirect` is true
}

export default Splash;
